import { useIsMobile } from '@/hooks';
import { ItemsGrafica } from '@/types/dashboard/TeminalPage';
import {
  Chart as ChartJS,
  ChartData,
  BarElement,
  CategoryScale,
  Legend,
  LinearScale,
  Tooltip,
} from 'chart.js';
import { useEffect, useRef } from 'react';
import { Bar } from 'react-chartjs-2';

type OneLabelTwoBarsChartProps = {
  data: ItemsGrafica[];
  colorForMetric?: string;
};

/* eslint-disable*/
const valueAboveBarsPlugin = {
  id: 'valueAboveBars',
  afterDatasetsDraw: (chart: any) => {
    const { ctx } = chart;
    chart.data.datasets.forEach((dataset: any, i: any) => {
      const meta = chart.getDatasetMeta(i);
      meta.data.forEach((bar: any, index: any) => {
        const value = dataset.data[index];
        ctx.fillStyle = '#223466';
        ctx.font = 'bold 14px';
        ctx.textAlign = 'center';
        const position = bar.tooltipPosition();
        ctx.fillText(value + '%', position.x, position.y - 10);
      });
    });
  },
};

const OneLabelTwoBarsChart: React.FC<OneLabelTwoBarsChartProps> = ({
  data,
  colorForMetric,
}) => {
  const chartRef = useRef<ChartJS<'bar'> | null>(null);
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Tooltip,
    Legend,
    valueAboveBarsPlugin
  );
  const isMobile = useIsMobile();
  const getOneLabelTwoDataChartData = (
    items: ItemsGrafica[]
  ): ChartData<'bar'> => {
    const labels = items.map((item) => {
      const date = new Date(item.fecha);
      const day = date.getDate();
      const month = date.getMonth() + 1;
      return `${day}/${month}`;
    });

    const porcentajeArmadorData = items.map((item) =>
      parseFloat(item.porcentajeArmador.toFixed(1))
    );
    const porcentajeTerminalData = items.map((item) =>
      parseFloat(item.porcentajeTerminal.toFixed(1))
    );

    return {
      labels,
      datasets: [
        {
          label: 'Porcentaje Armador',
          data: porcentajeArmadorData,
          backgroundColor: colorForMetric ?? 'purple',
          borderRadius: 6,
        },
        {
          label: 'Porcentaje Terminal',
          data: porcentajeTerminalData,
          backgroundColor: '#4780bf',
          borderRadius: 6,
        },
      ],
    };
  };
  const chartData: ChartData<'bar'> = getOneLabelTwoDataChartData(data);

  const options = {
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: isMobile ? 0 : 20, // Añadimos un padding superior para que los valores no se corten
      },
    },
    scales: {
      x: {
        display: true,
        align: 'center',
        grid: {
          lineWidth: 0,
        },
      },
      y: {
        display: false,
        lineWidth: 0,
      },
    },
    plugins: {
      legend: {
        display: false, // No mostrar leyenda
      },
      tooltip: {
        enabled: true,
      },
    },
    barPercentage: 0.9,
  };

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        chartRef.current.destroy();
      }
    };
  }, []);

  return <Bar data={chartData} options={options} />;
};

export default OneLabelTwoBarsChart;
